import { Component, OnInit } from '@angular/core';
import { OrderModel } from '@shared/models/data/order-model';
import { OrderSummaryModel } from '@shared/models/data/order-summary-model';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { SessionService } from '@shared/services/session.service';

@Component({
  selector: 'aaos-app-order-summary-page',
  templateUrl: './order-summary-page.component.html',
  styleUrls: ['./order-summary-page.component.scss']
})
export class OrderSummaryPageComponent implements OnInit {

  institutionId;
  orderSummaryModel: OrderSummaryModel;
  loading = true;
  productsAndOrders = new Map<string, Array<OrderModel>>();
  availableProducts = '';
  ordersExist = false;

  constructor(
    private enrollmentService: EnrollmentService,
    private sessionService: SessionService,
  ) { }

  ngOnInit() {
    this.institutionId = this.sessionService.getInstitutionId();
    this.setAvailableProductText();
    this.getOrderSummary();
  }

  setAvailableProductText() {
    this.enrollmentService.getActiveProducts().subscribe(products => {
      if (products.length === 1) {
        this.availableProducts = products[0].shortName;
      } else if (products.length === 2) {
        this.availableProducts = `${products[0].shortName} and ${products[1].shortName}`;
      } else if (products.length > 2) {
        this.availableProducts = `${products.map(x => x.shortName)
          .slice(0, -1).join(', ')}, and ${products[products.length - 1].shortName}`;
      }
    });
  }

  getOrderSummary() {
    this.institutionId = this.sessionService.getInstitutionId();
    this.enrollmentService.getOrderSummaryModel(this.institutionId).subscribe(x => {
      this.orderSummaryModel = x;
      this.ordersExist = this.orderSummaryModel.orders.length > 0;
      this.getProductAndOrders(this.orderSummaryModel);
      this.loading = false;
    });
  }

  getProductAndOrders(orderSummaryModel: OrderSummaryModel) {
    orderSummaryModel.orders.forEach(order => {
      if (this.productsAndOrders.has(order.productId)) {
        this.productsAndOrders.get(order.productId).push(order);
      } else {
        this.productsAndOrders.set(order.productId, [order]);
      }
    });
  }


}
